import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CancellationPolicy() {
  return (
    <div data-testid="cancellation-policy-page" className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-slate-50 border-b border-slate-100">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl py-6">
          <Link
            to="/"
            data-testid="back-to-home"
            className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 transition-colors font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 md:px-6 max-w-4xl py-12">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-8">
          Cancellation Policy
        </h1>

        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-6">
            <strong>Last Updated:</strong> December 2025
          </p>

          <p className="text-slate-600 mb-6">
            We understand that plans can change. Please review our cancellation policy below.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Cancellation Notice
          </h2>
          <p className="text-slate-600 mb-6">
            We kindly request at least <strong>24 hours notice</strong> for any appointment cancellations or rescheduling. This allows us to offer the appointment slot to other pet owners who may be waiting.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Late Cancellations
          </h2>
          <p className="text-slate-600 mb-6">
            Cancellations made less than 24 hours before the scheduled appointment may be subject to a cancellation fee. We understand emergencies happen, and we will work with you on a case-by-case basis.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            No-Shows
          </h2>
          <p className="text-slate-600 mb-6">
            If you do not show up for your appointment without prior notice, a no-show fee may apply. Please contact us if you are running late so we can accommodate you if possible.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            How to Cancel or Reschedule
          </h2>
          <p className="text-slate-600 mb-6">
            To cancel or reschedule your appointment, please contact us by:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Phone: +1-888-8801-344</li>
            <li>Email: bookings@cozynests.store</li>
          </ul>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Refunds
          </h2>
          <p className="text-slate-600 mb-6">
            If you have prepaid for services, refunds will be processed according to our cancellation timeline. Full refunds are available for cancellations made 24+ hours in advance.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Questions?
          </h2>
          <p className="text-slate-600 mb-4">
            If you have questions about our cancellation policy, please contact us:
          </p>
          <div className="text-slate-600 mb-8">
            <p><strong>Cozy Nests</strong></p>
            <p>20 E 22nd St #4699, New York, NY 10165</p>
            <p>Phone: +1-888-8801-344</p>
            <p>Email: bookings@cozynests.store</p>
          </div>
        </div>
      </main>
    </div>
  );
}
